import React from "react";

import { press } from "../../config";

export const PressSimple = ({ background }) => {
  return (
    <div className={background}>
      <div className="mx-auto py-16 lg:py-24 max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl px-8">
        <h2 className="text-3xl font-bold text-blue-500 text-center">
          Entérate lo que dicen de nosotros
        </h2>
        <div>
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {press.map((item, index) => (
              <a
                key={index}
                href={item.href}
                target="_blank"
                className="text-gray-400 hover:text-gray-800 p-7 flex flex-col items-center h-full"
              >
                <div className="flex flex-col items-center h-full">
                  <item.logo className="w-36 h-36 self-center" />
                  <p className="text-center text-gray-600 italic ">
                    {item.description}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
